import React, { useState } from 'react';
import "./Widgets.css";
import Messages from './Messages';
import ChatIcon from '@material-ui/icons/Chat';

function Widgets() {
    const [chat, setChat] = useState(false);
    const chatShow = () => setChat(!chat);

    return (
        <div className={chat? 'chat__widgets' : 'widgets'}>
            <Messages />
            <div className={chat? 'chat__icons' : 'chat__icon'} onClick={chatShow}>
                <ChatIcon />
            </div>
        </div>
    )
}

export default Widgets
